import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import InvitesModal from "../Components/Modals/InvitesModal";

type Props = NativeStackScreenProps<RootStackParamList, "Invites">;

const InvitesScreen: React.FC<Props> = ({ navigation }) => {
  return <InvitesModal onClose={() => navigation.goBack()} />;
};

export default InvitesScreen;
